export default __webpack_public_path__ + "static/media/Bamboo Javelin.3e27a2cd.jpg";